<template>
  <v-container fluid>
    <v-card flat class="font">
      <v-card-title>
        My Exemptions
        <v-spacer />
        <v-btn color="primary" @click="checkExemption()">
          Apply For Exemption
          <v-icon class="ml-2">mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="exemptions"
          :items-per-page="5"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          class="elevation-0"
          item-key="reg_no"
          fixed-header
        >
          <template v-slot:[`item.ID`]="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <span>{{ item.amount | currencyFormat }}</span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <span class="text-lowercase">
              <v-icon size="14" :color="statusColor[item.status.toLowerCase()]">
                mdi-radiobox-marked
              </v-icon>
              {{ statusWordings(item.status) }}
            </span>
          </template>
          <!-- <template v-slot:[`item.amount`]="{ item }">
            <span class="">{{ item.amount | currencyFormat }}</span>
          </template> -->
          <!--BEGIN Menu action-->
          <template v-slot:[`item.action`]="{ item }">
            <v-menu open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="text-capitalize links"
                  text
                  v-bind="attrs"
                  v-on="on"
                  small
                  ><v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  :to="{
                    name: 'ExemptionCard',
                    params: { code: encryptedViewParam(item.no) },
                  }"
                >
                  <v-icon color="primary">visibility</v-icon> View
                </v-list-item>

                <v-divider
                  v-if="item['postedReceiptNo'] || item['invoiceNo']"
                />

                <v-list-item
                  v-if="(item['postedReceiptNo'] || item['invoiceNo']) && (item?.status === 'Open' || item?.status === 'Pending Approval')"
                  :to="{
                    name: 'AcknoledgementLetter',
                    params: { code: item.no },
                  }"
                >
                  <v-icon color="teal">description</v-icon> Acknowledgement
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item
                  v-if="!item['invoiceNo']"
                  :to="{
                    name: 'ExemptionPayments',
                    params: { code: encryptedPaymentParam(item.no) },
                  }"
                >
                  <v-icon color="warning">payment</v-icon> Pay
                </v-list-item>

                <v-list-item
                  v-if="item['postedReceiptNo']"
                  :to="{
                    name: 'ExemptionReceipt',
                    params: { code: item.postedReceiptNo },
                  }"
                >
                  <v-icon color="secondary">description</v-icon> Receipt
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item
                  v-if="item.status === 'Open'"
                  @click="deleteExemption(item)"
                >
                  <v-icon color="deep-orange darken-4">delete</v-icon> Delete
                </v-list-item>

                <v-divider v-if="item.defer"></v-divider>

                <v-list-item
                  v-if="item?.defer || item?.status === 'Released'"
                  :to="{
                    name: 'ExemptionLetter',
                    params: { code: item.no },
                  }"
                >
                  <v-icon color="primary">mdi-file</v-icon>
                  Exemption Letter
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:[`footer.prepend`]>
            <a
              href="https://kiseb.or.ke/sites/default/files/KISEB/docs/Exemption%20Application%20Procedure.pdf"
              class="primary--text"
              target="_blank"
            >
              <span class="font-weight-light font1 mr-3">
                Need help applying for an exemption?
              </span>
            </a>
          </template>
          <!--END Menu action-->
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import status from "@/packages/applications/status.js";
import { helper } from "../../dashboard/utils";
import exemptionMixin from "../exemptionMixin";
export default {
  name: "ExemptionListComponent",
  mixins: [exemptionMixin],
  data: () => ({
    headers: [
      { text: "#S/N", sortable: true, value: "ID" },
      { text: "Code", sortable: true, value: "no" },
      {
        text: "Programme",
        align: "start",
        sortable: false,
        value: "programme",
      },
      { text: "Stage", sortable: false, value: "stage" },
      { text: "Amount (KES)", value: "amount" },
      { text: "Status", value: "status", sortable: true },
      { text: "Actions", value: "action", sortable: false },
    ],
    sortBy: "no",
    sortDesc: true,
  }),
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Exemption/exemptions");
    });
  },
  computed: {
    statusColor() {
      return status;
    },
    exemptions() {
      return this.$store.getters["Exemption/exemptionGetter"](
        "exemptions",
      ).sort((a, b) => new Date(b.documentDate) - new Date(a.documentDate));
    },
  },
  methods: {
    deleteExemption(item) {
      this.$confirm.show({
        title: `Delete Exemption ${item.no} ?`,
        text: "Are you sure you want to delete this exemption,this action is irreversible",
        onConfirm: () => {
          this.$store.dispatch("Exemption/deleteExemption", { ...item });
        },
      });
    },
    statusWordings(status) {
      if (status === "Released") {
        return "Approved";
      } else if (status === "Open" || status === "Pending Approval") {
        return "Processing";
      }
    },
    encryptedPaymentParam(item) {
      return helper.encrypt(item);
    },
    encryptedViewParam(item) {
      return helper.encrypt(item);
    },
    exemptionLetter(item) {
      this.$store.dispatch("Exemption/exemptionLetter", item.no);
    },
  },
};
</script>

<style scoped>
.font {
  font-family: "PT Sans Caption", sans-serif;
}
.font1 {
  font-size: 12px;
}
</style>
